<template>
  <b-card class="rounded-xl">
    <modal :show.sync="editModal" header-classes="bg-primary p-3">
      <h6 slot="header" class="modal-title text-white font-semibold pt-1">
        EDIT IMAGE ORDER
      </h6>
      <EditCategoryDetail />
      <template slot="footer">
        <base-button type="primary">SAVE CHANGES</base-button>
        <base-button type="secondary" class="ml-auto" @click="editModal = false"
          >CLOSE</base-button
        >
      </template>
    </modal>
    <AddCategorySidebar
      :isSidebarActive="openAddBannerSidebar"
      @closeSidebar="toggleAddBannerSidebar"
    />
    <div class="flex  justify-between  items-center">
      <div>
        <h2 class="text-2xl font-semibold">
          List Of Communitys
        </h2>

        <small class=" text-muted "
          >Manage the Community of your community here.
        </small>
      </div>
      <base-button type="warning" class="px-8" @click="addBanner">
        Export
      </base-button>
    </div>
    <!-- <b-input-group class="mt-12">
      <b-form-input
        class="border-none shadow-lg"
        type="text"
        min="0.00"
        placeholder="Enter Search...."
      ></b-form-input>

      <b-input-group-append>
        <b-button
          variant="white"
          class="flex items-center shadow-lg"
          aria-label="search"
        >
          <feather-icon
            class="cursor-pointer mr-2"
            icon="SearchIcon"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group> -->
    <UsersTable />
  </b-card>
</template>
<script>
import "../../scss/Index.scss";
import EditCategoryDetail from "./components/EditCategoryDetail";
import AddCategorySidebar from "./components/AddCategorySidebar";
import UsersTable from "./components/UsersTable";
export default {
  components: {
    EditCategoryDetail,
    AddCategorySidebar,
    UsersTable
  },
  data() {
    return {
      currentPage: 1,
      editModal: false,
      openAddBannerSidebar: false
    };
  },
  methods: {
    addBanner() {
      this.toggleAddBannerSidebar(true);
    },
    toggleAddBannerSidebar(val = false) {
      this.openAddBannerSidebar = val;
    }
  }
};
</script>
